import $ from 'jquery';

$(document).ready(() => {
    changeLinksHomeCategories();
    function changeLinksHomeCategories() {
        const anchorElements = $('.elementor-image').children();
        const anchorLinkElements = $(".elementor-widget-wrap").children(".categoriesHP").children().children().children().children().children().children();
        anchorElements.each(function () {
            const oldLink = $(this).attr("href");
            const oldUrl = window.location.href;
            const url = oldUrl.substring(0, oldUrl.length - 1);
            const newLink = url + oldLink;
            $(this).attr("href", newLink);
        });
        anchorLinkElements.each(function () {
            const oldLink = $(this).attr("href");
            const oldUrl = window.location.href;
            const url = oldUrl.substring(0, oldUrl.length - 1);
            const newLink = url + oldLink;
            $(this).attr("href", newLink);
        });
    }
});




// WEBPACK FOOTER //
// ./js/home.js